import pbfe from "./pbfe.js";
import { _, t } from "./i18n.js";
import createNavbar from "./navbar.js";
import { LANG_URL_MAP, getLang, navigate } from "./index.js";

var container, box;

function init(_container) {
    container = _container;
    
    box = new pbfe.Flexbox("column");
    box.element.id = "aboutScreen";
    box.element.className = "main-screen";
    
    // Navbar
    var navbar = createNavbar();
    box.appendChild(navbar);

    // Content Container
    var contentBox = new pbfe.Flexbox("column");
    contentBox.element.id = "aboutContentBox";
    contentBox.alignItems = "center";
    // Breadcrumb Container
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";

    // Breadcrumb
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    
    // Home Link
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    t(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", () => {
        var lang = getLang();
        var prefix = LANG_URL_MAP[lang];
        var path = prefix ? "/" + prefix : "/";
        
        navigate(path);
    });
    breadcrumb.appendChild(homeLink);
    
    // Separator
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    
    // Current Page
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    t(current, "About");
    breadcrumb.appendChild(current);
    
    contentBox.appendChild({ element: breadcrumbContainer });
    
    // About Main Container
    var aboutContainer = document.createElement("div");
    aboutContainer.className = "about-page-container";

    // --- Header Section ---
    var header = document.createElement("div");
    header.className = "about-page-header";

    var icon = document.createElement("img");
    icon.src = new URL('./icons/icon.svg', import.meta.url);
    icon.className = "about-page-icon";
    icon.alt = "Avatar Cropper Icon";
    header.appendChild(icon);

    var title = document.createElement("h1");
    title.className = "page-title";
    title.innerText = "Avatar Cropper";
    header.appendChild(title);

    var version = document.createElement("div");
    version.className = "about-page-version";
    version.innerText = "v" + process.env.npm_package_version;
    header.appendChild(version);

    aboutContainer.appendChild(header);

    // --- Content Section ---
    var content = document.createElement("div");
    content.className = "about-page-content";

    var tagline = document.createElement("div");
    tagline.className = "about-tagline";
    t(tagline, "Quickly Crop Avatar for Discord, X (Twitter), etc.");
    content.appendChild(tagline);

    var desc = document.createElement("div");
    desc.className = "about-desc";
    t(desc, "Quick and accurate avatar cropper tool. Crop perfect avatar for Discord, X, etc. No signup required.");
    content.appendChild(desc);

    aboutContainer.appendChild(content);

    contentBox.appendChild({ element: aboutContainer });
    
    box.appendChild(contentBox);
}

function show() {
    container.appendChild(box);
}

function hide() {
    if (box && box.element.parentNode) {
        box.element.parentNode.removeChild(box.element);
    }
}

var aboutScreen = {
    init, show, hide
};

export default aboutScreen;
